import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { Button, Text } from '@intellecteu/common-ui';
import { Popup } from 'ui';

import s from './styles.module.scss';

interface IPopup {
  overlayedItemId: string;
  closeFunction: (...args: unknown[]) => void;
  children?: ReactNode;
  title: string;
  type?: string;
  text: string;
}

interface IPopupContainer extends IPopup {
  onKeyDown: (...args: unknown[]) => void;
}

const PopupContainer = ({
  overlayedItemId,
  closeFunction,
  text,
  children,
  onKeyDown,
  type,
  title,
  ...props
}: IPopupContainer) => {
  const modalRoot = document.getElementById('modal-root') as HTMLElement;

  useEffect(() => {
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, []);

  return createPortal(
    <Popup
      className={s.popupContainer}
      title={title}
      closeFunction={closeFunction}
      overlayedItemId={overlayedItemId}
      {...props}
    >
      <Text className={type === 'remove' && s.popupText}>{text}</Text>
      {children}
    </Popup>,
    modalRoot,
  );
};

interface IProcessingPopup extends IPopup {
  action: (...args: unknown[]) => void;
}
export const ProcessingPopup = ({ closeFunction, children, type = 'remove', action, ...props }: IProcessingPopup) => {
  const [isAddMode, setIsAddMode] = useState(false);

  const onKeyDownFn = (e) => {
    if (e.keyCode === 13) {
      if (isAddMode) {
        closeFunction(e);
      } else {
        action(e);
      }
    }
    if (e.keyCode === 27) {
      closeFunction(e);
    }
  };

  useEffect(() => setIsAddMode(type.includes('add')), [type]);

  return (
    <PopupContainer {...props} onKeyDown={onKeyDownFn} closeFunction={closeFunction} type={type}>
      {children}
      <div className={s.processingPopupButtons}>
        {isAddMode ? (
          <Button className={s.processingPopupButtonsButton} onClick={closeFunction}>
            Ok
          </Button>
        ) : (
          <>
            <Button variant="secondary" className={s.processingPopupButtonsItem} onClick={closeFunction}>
              Cancel
            </Button>
            <Button className={s.processingPopupButtonsItem} onClick={action}>
              Confirm
            </Button>
          </>
        )}
      </div>
    </PopupContainer>
  );
};
